import React, { FC, useEffect, useState, useContext } from 'react'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { IssueView } from '.'
import ROUTES from '../utils/routes'
import { Spinner } from '../System'
import { getIssueBySlugQuery } from '../../graphql/Issue/getIssueBySlug'
import {
  GetIssueBySlug,
  GetIssueBySlug_issueFindOne
} from '../../graphql/Issue/__generated__/GetIssueBySlug'
import useSegment from '../utils/useSegment'
import { userStore } from '../utils/UserContext'

const Issue: FC = () => {
  const history = useHistory()
  const { slug }: any = useParams()
  const { track } = useSegment()
  const location = useLocation()
  const { user } = useContext(userStore)
  const [issue, setIssue] = useState<GetIssueBySlug_issueFindOne | null>()

  const { data } = useQuery<GetIssueBySlug>(getIssueBySlugQuery, {
    fetchPolicy: 'no-cache',
    variables: { slug }
  })

  const sendUserToLogin = () => {
    history.push({
      pathname: ROUTES.errors.notLoggedIn,
      state: { backUrl: location.pathname }
    })
  }

  useEffect(() => {
    if (!data) {
      return
    }

    if (!user || user.stripeSubscriptionStatus !== 'Active') {
      sendUserToLogin()
      return
    }

    if (!data.issueFindOne || data.issueFindOne.status !== 'published') {
      history.push(ROUTES.errors.notFound)
      return
    }

    setIssue(data.issueFindOne)
  }, [slug, data])

  useEffect(() => {
    if (issue) {
      track('Viewed Issue', { issue_name: issue?.title, issue_id: issue._id })
    }
  }, [!!issue])

  if (!issue) {
    return <Spinner isBlock />
  }

  return <IssueView issue={issue} />
}

export default Issue
